module.exports = __webpack_public_path__ + "static/favicon-90158eda09e9f7b037c49696713d6345.ico";